import * as React from 'react';
import * as Redux from 'react-redux';
import { allTiposActividadesExtcurAction } from '../TiposActividadesExtcurAction';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';

const SelectFieldTiposActividadesExtcurComponent = ({
  onChange,
  value,
  data,
  required = false,
  selects = [],
}) => {
  const dispatch = Redux.useDispatch();

  const tiposActividadesExtcurStore = Redux.useSelector(
    (state) => state.tiposActividadesExtcur,
  );

  const [tiposActividadesExtcur, setTiposActividadesExtcur] = React.useState(
    [],
  );

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      tiposActividadesExtcurStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setTiposActividadesExtcur(items);
    } else {
      if (data) {
        setTiposActividadesExtcur(data);
      } else {
        setTiposActividadesExtcur(tiposActividadesExtcurStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (
        !data &&
        tiposActividadesExtcurStore.all &&
        tiposActividadesExtcurStore.all.length === 0
      ) {
        await allTiposActividadesExtcurAction(dispatch, null);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  return (
    <FormControl fullWidth size="small" required={required}>
      <InputLabel id={`label_actividadextcur_${CONST.tipo.name}`}>
        {CONST.tipo.label}
      </InputLabel>
      <Select
        id={CONST.tipo.name}
        value={value}
        labelId={`label_actividadextcur_${CONST.tipo.name}`}
        label={CONST.tipo.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {tiposActividadesExtcur.map((el, index) => {
          return (
            <MenuItem key={`tipo-actividadextcur-${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SelectFieldTiposActividadesExtcurComponent;
